import React from 'react';
import { Grid3x3, Edit, Trash2, Maximize2, Package, Percent, Scissors } from 'lucide-react';

const BoardCard = ({ board, onEdit, onDelete, onViewCut }) => {
  const statusColors = {
    EMPTY: 'bg-gray-50 text-gray-700 border-gray-200',
    PARTIAL: 'bg-amber-50 text-amber-700 border-amber-200',
    COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    CANCELLED: 'bg-red-50 text-red-700 border-red-200'
  };

  const efficiency = parseFloat(board.efficiency_percentage) || 0;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:border-gray-300 transition-colors">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
            <Grid3x3 className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">{board.board_number}</h3>
            <p className="text-sm text-gray-500">
              {board.width} x {board.height}mm
            </p>
          </div>
        </div>
        <span className={`px-2 py-1 text-xs font-medium rounded border ${statusColors[board.status] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
          {board.status}
        </span>
      </div>

      <div className="space-y-2 mb-3">
        {board.material_name && (
          <p className="text-sm text-gray-600">
            <span className="font-medium">Material:</span> {board.material_name}
          </p>
        )}
        {board.thickness && (
          <p className="text-sm text-gray-600">
            <span className="font-medium">Espessura:</span> {board.thickness}mm
          </p>
        )}
        <p className="text-sm text-gray-600 flex items-center gap-1">
          <Maximize2 className="w-3 h-3" />
          <span className="font-medium">Área Total:</span> {parseFloat(board.total_area || 0).toFixed(3)} m²
        </p>
        <p className="text-sm text-gray-600 flex items-center gap-1">
          <Package className="w-3 h-3" />
          <span className="font-medium">Usada:</span> {parseFloat(board.used_area || 0).toFixed(3)} m²
        </p>
      </div>

      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1">
          <Percent className="w-4 h-4 text-gray-400" />
          <span className="text-sm font-medium">Aproveitamento:</span>
          <span className={`text-sm font-bold ${
            efficiency >= 70 ? 'text-emerald-600' :
            efficiency >= 50 ? 'text-amber-600' :
            'text-red-600'
          }`}>
            {efficiency.toFixed(1)}%
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-gray-200">
        <button
          onClick={() => onViewCut?.(board)}
          className="flex items-center gap-1 px-3 py-1.5 text-sm text-blue-600 hover:text-white hover:bg-blue-600 border border-blue-600 rounded-lg transition-colors"
        >
          <Scissors className="w-4 h-4" />
          Visualizar Corte
        </button>
        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit?.(board)}
            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
          >
            <Edit className="w-4 h-4" />
          </button>
          <button
            onClick={() => onDelete?.(board)}
            className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoardCard;
